import React from "react";
import SettingsSectionTitle from "../SettingsSectionTitle";
import screenPlayIcon from "../../../assets/icons/screen-play.webp";
import UploadButton from "./UploadButton";
import MediaPreview from "./MediaPreview";
import ErrorMessage from "./ErrorMessage";
import { useUpload } from "./hooks/useUpload";
import { useDashboard } from "../../../hooks/useDashboard";

const UploadImage: React.FC = () => {
  const { uploadedFile, isUploading, error, handleFileUpload, handleError } =
    useUpload();
  const { status } = useDashboard();

  // Check for existing media - could be in video or image field
  const existingMedia = status?.image || status?.video;
  const hasExistingMedia = !!existingMedia;

  const uploadButton = (
    <UploadButton
      isUploading={isUploading}
      isUploaded={!!uploadedFile || hasExistingMedia}
      onFileSelect={handleFileUpload}
      onError={handleError}
      maxSizeInMB={16}
    />
  );

  return (
    <>
      <SettingsSectionTitle
        title="העלאת מדיה:"
        subtitle="קובץ עד 16 מגה"
        icon={screenPlayIcon}
        uploadButton={uploadButton}
      />
      <ErrorMessage message={error} />
      {uploadedFile ? (
        <MediaPreview file={uploadedFile} />
      ) : hasExistingMedia ? (
        <MediaPreview mediaUrl={existingMedia!} />
      ) : null}
    </>
  );
};

export default UploadImage;
